import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PaymentsTable from 'components/admin/PaymentsTable';
import OverduePaymentsTable from 'components/admin/OverduePaymentsTable';
import Loader from 'components/general/Loader';

function InvoicesTab({
    fsPayments,
    solarPayments,
	fsCompanies,
	solarCompanies,
	getPayments,
	updatePayment,
	showSuccessAlert
}) {

    const [product, setProduct] = useState('Financial');
    const [showStatus, setShowStatus] = useState('invoiced');
    const [selectedCompany, setSelectedCompany] = useState('all');

    // Helper to determine if a payment matches the selected status, supporting both new and old fields
    function paymentMatchesStatus(payment, status) {
        // New unified statuses: pending, processing, invoiced, paid
        if (typeof payment.status === 'string') {
            if (status === 'invoiced') {
                // Treat both 'invoiced' and 'processing' as unpaid invoices to be shown
                return payment.status === 'invoiced' || payment.status === 'processing';
            }
            if (status === 'paid') {
                return payment.status === 'paid';
            }
            return payment.status === status;
        }
        // Fallback for old invoices (no unified status field)
        if (status === 'invoiced') {
            // Show unpaid invoices: invoiced=true, paid=false
            return payment.invoiced === true && payment.paid !== true;
        }
        if (status === 'paid') {
            return payment.paid === true;
        }
        return false;
    }

    const companies = product === 'Financial' ? fsCompanies : solarCompanies;

    // Compute filtered payments based on product, status, and company
    const showPayments = (product === 'Financial'
        ? fsPayments.filter(payment => paymentMatchesStatus(payment, showStatus))
        : solarPayments.filter(payment => paymentMatchesStatus(payment, showStatus))
    ).filter(payment => selectedCompany === 'all' || payment.companyId === selectedCompany);

    function updateShowStatus(showStatus) {
        setShowStatus(showStatus);
    }

    async function updateProduct(product) {
        setProduct(product);
        setSelectedCompany('all');
    }

	return (
        <Grid container>
            <Grid item xs={12}>
                <Grid
                    container
                    component={Box}
                    alignItems='center'
                    justifyContent='flex-start'
                    style={{marginBottom: '2rem'}}
                    direction='row'
                >
                    <Grid item xs={12} md={2}>
                        <FormGroup style={{marginBottom: '0'}}>
                            <FormControl variant='outlined' fullWidth>
                                <Select
                                    multiple={false}
                                    value={product}
                                    onChange={(e) => updateProduct(e.target.value)}
                                >
                                    <MenuItem value={'Financial'}>Financial</MenuItem>
                                    <MenuItem value={'Solar'}>Solar</MenuItem>
                                </Select>
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormGroup style={{marginBottom: '0'}}>
                            <FormControl variant='outlined' fullWidth>
                                <Select
                                    multiple={false}
                                    value={showStatus}
                                    onChange={(e) => updateShowStatus(e.target.value)}
                                >
                                    <MenuItem value={'invoiced'}>Unpaid</MenuItem>
                                    <MenuItem value={'paid'}>Paid</MenuItem>
                                </Select>
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormGroup style={{marginBottom: '0'}}>
                            <FormControl variant='outlined' fullWidth>
                                <Select
                                    multiple={false}
                                    value={selectedCompany}
                                    onChange={(e) => setSelectedCompany(e.target.value)}
                                >
                                    <MenuItem value={'all'}>All Companies</MenuItem>
                                    {companies.map((company) => (
                                        <MenuItem key={company.companyId} value={company.companyId}>{company.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </FormGroup>
                    </Grid>
                </Grid>
            </Grid>
            {showStatus === 'invoiced' &&
                <Grid item xs={12}>
                    <OverduePaymentsTable 
                        payments={showPayments}
                    />
                </Grid>
            }
            <Grid item xs={12}>
                <PaymentsTable 
                    payments={showPayments}
                    companies={companies}
                    refreshPayments={() => getPayments(product)}
                    // Pass product first to match Payments.js updatePayment(type, payment)
                    updatePayment={(updatedPayment) => updatePayment(product, updatedPayment)}
                    showSuccessAlert={(text) => showSuccessAlert(text)}
                    product={product}
                />
            </Grid>
        </Grid>
	);
}

export default InvoicesTab;
